const plants = {
	plant1: {
		id: 1,
		name: "Monstera",
		latin: "Monstera Deliciosa",
		price: 3300,
		desc:
			"Nicknamed the “swiss cheese plant,” the Monstera deliciosa is famous for its quirky natural leaf holes. A vibrant green beauty, it can give any interior space instant jungle vibes.",
		img: "/img/monstera-deliciosa.jpg",
		imgSmall: "/img/monstera-deliciosa-small.jpg",
		sku: "sku_GscPH2ucN3ehDg"
	},
	plant2: {
		id: 2,
		name: "Bird’s Nest Fern",
		latin: "Asplenium Nidus",
		price: 3900,
		desc:
			"If you’re looking for the perfect tropical houseplant, look no further than the Bird’s Nest Fern. Known for its wavy ripple-edge fronds that grow out of a central rosette, this plant will add vibrant pop of green to any space. We love it because it’s considered non-toxic, making it safe to keep around your furry friends.",
		img: "/img/birds-nest-fern.jpg",
		imgSmall: "/img/birds-nest-fern-small.jpg",
		sku: "sku_Gsq479X69WMVJY"
	},
	plant3: {
		id: 3,
		name: "ZZ Plant",
		latin: "Zamioculcas zamiifolia",
		price: 4400,
		desc:
			"The ZZ Plant is characterized by its thick waxy green leaves. It is a great air purifying plant for beginners.",
		img: "/img/zz-plant.jpg",
		imgSmall: "/img/zz-plant-small.jpg",
		sku: "sku_Gsq6QzeGPw09V7"
	},
	plant4: {
		id: 4,
		name: "Snake Plant",
		latin: "Dracaena trifasciata",
		price: 3300,
		desc:
			"The Snake Plant Laurentii is a succulent plant characterized by its upright swordlike leaves with vibrant yellow edges.",
		img: "/img/snake-plant-laurentii.jpg",
		imgSmall: "/img/snake-plant-laurentii-small.jpg",
		sku: "sku_Gsq6bXFZ2n8roa"
	},
	plant5: {
		id: 5,
		name: "Calathea",
		latin: "Calathea roseopicta",
		price: 6200,
		desc:
			"The Calathea Medallion gets its name from the unique roundness of its leaves. They have a brilliant green pattern on top, and are a deep burgundy underneath.",
		img: "/img/calathea-medallion.jpg",
		imgSmall: "/img/calathea-medallion-small.jpg",
		sku: "sku_Gsq6GMbqYaglt3"
	},
	plant6: {
		id: 6,
		name: "Pilea",
		latin: "Pilea Peperomioides",
		price: 3300,
		desc:
			"The Pilea peperomioides, also called the pancake or UFO plant, is known for its cute coin-shaped leaves. A self-propagator, the Pilea produces sweet little babies or “pups” on it’s own, which pop up from the soil surrounding the mother plant..",
		img: "/img/pilea.jpg",
		imgSmall: "/img/pilea-small.jpg",
		sku: "sku_Gsq79iGHzHSWTK"
	},
	plant7: {
		id: 7,
		name: "Maranta",
		latin: "Maranta leucomeura",
		price: 4000,
		desc:
			"Nicknamed the “prayer plant”, the Maranta is famous for the unique movements of its dramatic foliage.",
		img: "/img/maranta.jpg",
		imgSmall: "/img/maranta-small.jpg",
		sku: "sku_Gsq7eFBBn0beiS"
	},
	plant8: {
		id: 8,
		name: "Marble Queen Pothos",
		latin: "Epipremnum aureum ‘Marble Queen’",
		price: 3300,
		desc:
			"The Pothos Marble and its quick growing vines full of variegated green and white leaves will make any space look more lush. It is a great choice for beginners.",
		img: "/img/pothos.jpg",
		imgSmall: "/img/pothos-small.jpg",
		sku: "sku_Gsq707fgpber0y"
	}
};

export default plants;
